import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { createResourceLocatorString } from '../../../../util/routes';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';

import Field, { hasDataInFields } from '../../../../containers/PageBuilder/Field';
import SectionContainer from '../../../../containers/PageBuilder/SectionBuilder/SectionContainer';
import SearchGroup from '../SearchGroup/SearchGroup';
import { HERO_BANNER_SECTION_ID } from '../../config/constants';

import css from './SectionHeroCustom.module.css';

const SectionHeroCustom = props => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const { landingPage } = useSelector(state => state?.hostedAssets?.pageAssetsData);
  const banner = landingPage.data.sections?.find(
    section => section.sectionId === HERO_BANNER_SECTION_ID
  )?.blocks;
  
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    options,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const handleSubmit = values => {
    const searchParams = () => {
      const { search, selectedPlace } = values?.location || {};
      const { bounds } = selectedPlace || {};

      return {
        address: search,
        bounds,
        keywords: values?.keywords,
      };
    };

    history.push(
      createResourceLocatorString('MapViewPage', routeConfiguration, {}, searchParams())
    );
  };

  return (
    <div className={css.rootClassName}>
      <SectionContainer
        id={sectionId}
        className={className}
        rootClassName={classNames(rootClassName || css.root)}
        appearance={appearance}
        options={fieldOptions}
        banner={banner}
        customClasses={css}
      >
        {hasHeaderFields ? (
          <header className={classNames(defaultClasses.sectionDetails, css.sectionDetails)}>
            <Field
              data={{ ...title, content: 'Farmers, growers, makers.' }}
              className={classNames(defaultClasses.title, css.title)}
              options={fieldOptions}
            />
            <Field
              data={{ ...description, content: 'Find the ones who do it properly.' }}
              className={classNames(defaultClasses.description, css.description)}
              options={fieldOptions}
            />
            <SearchGroup onSubmit={handleSubmit} />
          </header>
        ) : null}
      </SectionContainer>
    </div>
  );
};

export default SectionHeroCustom;
